
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ourworks",
      function () {
        return require("private-next-pages/ourworks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ourworks"])
      });
    }
  